// extracted by mini-css-extract-plugin
export default {"nav":"SliderNavButtons_nav__n0cUs","nav__btn":"SliderNavButtons_nav__btn__NkKAe"};